<template>
  <div class="col-12 col-md-12 col-lg-10">
    <div class="tit text-center">
      <p>
        Por favor, nos diga, qual o regime tributário da empresa?
        <a href="https://ajuda.iouu.com.br/hc/pt-br/articles/360006040833" target="_blank" class="infos">
          <at-popover trigger="hover" placement="right" content="Dúvidas? Clique aqui!">
            <i class="fas fa-info-circle"></i>
          </at-popover>
        </a>
      </p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-12 col-lg-9 col-xl-9">
        <form @submit="onSubmit">
          <ul class="list-group">
            <li class="list-group-item">
              <div class="form-check">
                <div class="checkContainer">
                  <input class="form-check-input" v-model.number="regimeTributario" type="radio" name="RegimeTributario" id="SIMEI" value="1" required>
                  <span class="checkmark"></span>
                    <label class="form-check-label" for="mei">MEI</label>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-check">
                <div class="checkContainer">
                  <input class="form-check-input" v-model.number="regimeTributario" type="radio" name="RegimeTributario" id="SimplesNascional" value="2" required>
                  <span class="checkmark"></span>
                    <label class="form-check-label" for="me">Simples Nacional</label>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-check">
                <div class="checkContainer">
                  <input class="form-check-input" v-model.number="regimeTributario" type="radio" name="RegimeTributario" id="SimplesNascional" value="3" required>
                  <span class="checkmark"></span>
                    <label class="form-check-label" for="me">Lucro Presumido</label>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-check">
                <div class="checkContainer">
                  <input class="form-check-input" v-model.number="regimeTributario" type="radio" name="RegimeTributario" id="SimplesNascional" value="5" required>
                  <span class="checkmark"></span>
                   <label class="form-check-label" for="me">Lucro Real</label>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-check">
                <div class="checkContainer">
                  <input class="form-check-input" v-model.number="regimeTributario" type="radio" name="RegimeTributario" id="SimplesNascional" value="4" required>
                  <span class="checkmark"></span>
                    <label class="form-check-label" for="me">Lucro Arbitrado</label>
                </div>
              </div>
            </li>
          </ul>
          <div class="text-center fixedOptions">
            <button v-focus class="btn btn-lg btn-primary">Próximo</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        regimeTributario: this.solicitacao.Empresa.RegimeTributario,
      }
    },
    props: {
      solicitacao: {required: true, type: Object}
    },
    methods: {
      onSubmit(e) {
        e.preventDefault()

        let regimeTributario = this.regimeTributario;
        let newData = {Empresa: {RegimeTributario: regimeTributario}};

        this.$emit('on-submit', newData)
      }
    }
  }
</script>

<style lang="css" scoped>
 .infos i {
   color: #999;
 }
</style>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/TributationStep.vue